
import { defineComponent, onMounted, onBeforeUnmount, watch, reactive, toRefs, nextTick } from 'vue'
import { useRouter, RouteLocationNormalized } from 'vue-router'
import Navbar from '@/components/App/Navbar/index.vue'
import SponsorFooter from '@/components/App/SponsorFooter.vue'
import Footer from '@/components/App/Footer.vue'
import FullPageProgress from '@/components/App/FullPageProgress.vue'
import Popup from '@/components/App/Popup/index.vue'

import '@/assets/scss/app.scss'
import { useStore } from './store'

export default defineComponent({
  name: 'App',
  components: {
    Navbar,
    SponsorFooter,
    Footer,
    FullPageProgress,
    Popup
  },
  setup () {
    const router = useRouter()
    const {
      startDetectBreakpoint, stopDetectBreakpoint,
      startDetectTheme, stopDetectTheme, showAnnouncement, announcementHasUpdated,
      isFullPageProgressLoading,
      isScrollLocked,
      currentScrollLockedPosition,
      isPopup
    } = useStore()

    const data = reactive({
      isInApp: false
    })

    const detectAnnouncementRoute = () => {
      if (router.currentRoute.value.query.popUp === 'announcement') {
        const onClose: () => void = () => {
          const query = { ...router.currentRoute.value.query }
          delete query.popUp
          router.push({
            ...(router.currentRoute.value),
            query
          })
        }
        showAnnouncement(onClose)
      }
    }

    const detectAnnouncementUpdate = () => {
      if (announcementHasUpdated.value) {
        router.push({
          query: {
            ...router.currentRoute.value.query,
            popUp: 'announcement'
          }
        })
      }
    }

    const onRouteChange = (to: RouteLocationNormalized) => {
      data.isInApp || (data.isInApp = to.query.mode === 'app')
      data.isInApp || detectAnnouncementRoute()
    }

    const onAppRender = () => {
      setTimeout(() => {
        data.isInApp || detectAnnouncementUpdate()
      }, 1000)
    }

    watch(() => router.currentRoute.value, onRouteChange)

    onMounted(async () => {
      document.addEventListener('x-app-rendered', onAppRender)
      startDetectBreakpoint()
      startDetectTheme()
      await nextTick()
      onRouteChange(router.currentRoute.value)
    })

    onBeforeUnmount(() => {
      stopDetectBreakpoint()
      stopDetectTheme()
    })

    return {
      isFullPageProgressLoading,
      isScrollLocked,
      currentScrollLockedPosition,
      isPopup,
      ...toRefs(data)
    }
  }
})
